import { createFileRoute, redirect } from '@tanstack/react-router';

// La file « À classer » est fusionnée dans /transactions (filtre « À classer »).
// On conserve la route pour ne pas casser liens/bookmarks : elle redirige.
export const Route = createFileRoute('/transactions/unclassified')({
  beforeLoad: () => {
    throw redirect({ to: '/transactions' });
  },
});
